import React, { useEffect, useMemo, useState } from 'react';
import { useFormik } from 'formik';
import { Box, Button, Card, CardContent, CardHeader, Grid, IconButton, Tooltip} from '@material-ui/core';
import { CustomGridProperties, Field } from '../../helpers';
import { FormProvider } from '../../contexts/FormCtx';
import { Tabs, Tab } from 'react-bootstrap';


import "./RealForm.css";

export const DetailsForm = (props) => {

  const { devMode, isFetching, id, action, snack, config, item, flow, data, editItem, addItem, validationSchema, onChangeConfirm, updateLocalItem, addLocalItem, selectedTab, setSelectedTab, setNoSavedChanges }  = props;
  const [ state, setState ] = useState({});
  const [ localTab, setLocalTab ] = useState(selectedTab);
  const [ valid, setValid ] = useState(false);

  useEffect(()=>{
    setState({loaded: true})
  }, [])



  //useEffect(()=>{
  //  setLocalTab(selectedTab);
  //}, [selectedTab])

  //console.log(selectedTab)

  const handleChangeTab = (key) => {
    setLocalTab(key);
  };

  const handleThumbstackClick = (key) => {
    setSelectedTab(key);
  }

  const handleSaveClick = (event) => {
    event.preventDefault();
    formik.submitForm();
  }
  
  //console.log("Render Form", item);

  const formik = useFormik({
    initialValues: {id: 0, ...item},
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: values => {
    },
    
  });

  const handleChangeValues = (values) => {
  }

  const tabs = Object.values( config.fields.reduce((prev, curr) => {
    const tab = curr.type.startsWith("Tab") 
      ? { name: curr.name, caption: curr.caption, fields: [curr], variant: "standard", disabled: action === "add", } 
      : {...prev.propiedades, fields: [curr]};
    return prev[tab.name] 
      ? {...prev, [tab.name]: {...tab, fields: [...prev[tab.name].fields, ...tab.fields]} }
      : {...prev, [tab.name]: tab};
  }, {propiedades: {name: "propiedades", caption: "Propiedades", fields: [], variant: "wrapper", disabled: false}})); 

  return (
    <>
      {state.loaded && 
        <Card elevation={0} style={{height: "100%"}}>
          <CardHeader title={"Detalles"}/>
          <CardContent>
            <FormProvider {...{...props, formik}}>
              <CardContent>
                <Tabs
                  activeKey={localTab}
                  onSelect={handleChangeTab}
                  className="mb-6"
                  mountOnEnter={true}
                >
                  {
                    tabs.map((tab, tabIndex )=> 
                      <Tab 
                        disabled={tab.disabled}
                        eventKey={tab.name} 
                        title={
                          <div>
                            <>
                              {tab.caption}
                              {tabs.length > 1 && selectedTab===tab.name && <IconButton style={{padding: 2, marginLeft: 2}} disabled={true}><ThumbstackActive/></IconButton>}
                              {
                                tabs.length > 1 && localTab === tab.name && selectedTab!==tab.name && 
                                  <Tooltip title="Fijar esta pestaña" aria-label="add" placement="top">
                                    <IconButton style={{padding: 2, marginLeft: 4}} onClick={()=>handleThumbstackClick(tab.name)}>
                                      <Thumbstack/>
                                    </IconButton>
                                  </Tooltip>
                              }
                            </>
                          </div>
                        }  
                      >
                        {tabIndex === 0 &&
                          <CustomGridProperties onValidChange={setValid} validationSchema={props.validationSchema && props.validationSchema.innerType} {...{data, item, fields: tab.fields.map(x => ({...x, details: true})), rootValues: formik.values}} initialValues={formik.values} onChange={handleChangeValues} />
                        }
                        {tabIndex > 0 &&
                          <Grid container spacing={2} >
                            {tab.fields.map((x, index)=> 
                              <Field devMode={devMode} key={index} {...{rootValues: formik.values, formik, data, item: item, validationSchema: props.validationSchema.fields[x.name]}} field={x} variant={tab.variant} details={true} />
                            )}
                          </Grid>
                        }
                      </Tab>
                    )
                  }
                </Tabs>
              </CardContent>  
            </FormProvider>
          </CardContent>          
        </Card>
      }
    </>
  );
}


const Thumbstack = ({width = 12, fill = "var(--color-oqt-active)"}) =>{
  return <svg style={{width, fill}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" ><path d="M300.8 203.9L290.7 128H328c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24H56C42.8 0 32 10.8 32 24v80c0 13.2 10.8 24 24 24h37.3l-10.1 75.9C34.9 231.5 0 278.4 0 335.2c0 8.8 7.2 16 16 16h160V472c0 .7.1 1.3.2 1.9l8 32c2 8 13.5 8.1 15.5 0l8-32c.2-.6.2-1.3.2-1.9V351.2h160c8.8 0 16-7.2 16-16 .1-56.8-34.8-103.7-83.1-131.3zM33.3 319.2c6.8-42.9 39.6-76.4 79.5-94.5L128 96H64V32h256v64h-64l15.3 128.8c40 18.2 72.7 51.8 79.5 94.5H33.3z"></path></svg>
}

const ThumbstackActive = ({width = 12, fill = "var(--color-oqt-active)"}) =>{
  return <svg style={{width, fill}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" ><path d="M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"></path></svg>
}